import {
  Outlet,
} from 'react-router-dom';
import useAuth from "../../hooks/use-auth";
import {useEffect} from "react";
import {getRefreshToken, getToken, tokenExpiresAt} from "../../tokenStorage";

const ProtectedRoute = ({ children }) => {
  const { consumeRefreshToken, onLogout } = useAuth();
  const token = getToken();

  useEffect(() => {
    if (!token) {
      onLogout();
      return;
    }

    if (new Date() >= new Date(tokenExpiresAt(token))) {
      consumeRefreshToken(getRefreshToken());
    }
  }, [token])

  return children ? children : <Outlet />;
};

export default ProtectedRoute;